/**
 * OVERRIDE TextBlockView
 * REASON: Add anchor link to heading element.
 * FILE VERSION: volto-slate@5.3.5
 * TICKET: Need to add.
 * DATE: 15-11-2023
 * DEVELOPER: @iFlameing
 */

import {
  serializeNodes,
  serializeNodesToText,
} from '@plone/volto-slate/editor/render';
import config from '@plone/volto/registry';
import Slugger from 'github-slugger';
import { normalizeString } from 'volto-fzj-internet/helpers';

const TextBlockView = (props) => {
  const { id, data, styling = {} } = props;
  const { value, override_toc } = data;
  const metadata = props.metadata || props.properties;

  return serializeNodes(
    value,
    (node, path) => {
      const res = { ...styling };
      if (node.type) {
        if (
          config.settings.slate.topLevelTargetElements.includes(node.type) ||
          override_toc
        ) {
          const text = serializeNodesToText(node?.children || []);
          const slug = Slugger.slug(normalizeString(text));
          res.id = slug || id;
        }
      }
      return res;
    },
    { metadata: metadata },
  );
};

export default TextBlockView;
